import React from "react";

// Lot 765 — onglets sous l'en-tête « Utilisateurs » (façon Vérifications KYC) : Membres · Par pays · Par jour · Connectés.
// `items` = entrées du hub autorisées pour le rôle (clé `users` + `hub: "users"`), dans l'ordre du menu.
export const HUB_LABELS = { users: "Membres", summary: "Résumés", installs: "Par pays", signups: "Par jour", active: "Connectés" };
export const USERS_HUB_KEYS = Object.keys(HUB_LABELS);

export const UsersHubTabs = ({ items, active, onPick }) => (
  <div className="flex gap-2 flex-wrap mt-3" role="tablist" data-testid="users-hub-tabs">
    {items.map((n) => {
      const on = n.key === active;
      const Icon = n.icon;
      return (
        <button key={n.key} type="button" role="tab" aria-selected={on} onClick={() => onPick(n.key)}
                className={`pill inline-flex items-center gap-1.5 ${on ? "pill-primary" : "pill-outline"}`} data-testid={`users-hub-tab-${n.key}`} data-active={on ? "1" : "0"}>
          {Icon && <Icon size={14} />} {HUB_LABELS[n.key] || n.label}
        </button>
      );
    })}
  </div>
);
